import React, { useContext, useState } from "react";
import { Menu, MenuItem, Tooltip } from "@material-ui/core";
import BusinessIcon from "@material-ui/icons/Business";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CheckIcon from "@material-ui/icons/Check";
import { useTranslation } from "react-i18next";
import SelectedCompanyContext from "../../../context/selected-company-context";

const CompanyKeySelector = ({ expanded }) => {
  const {
    is_company_keys_user,
    company_keys,
    selected_company_key,
    setSelectedCompanyKey,
    companies_map,
  } = useContext(SelectedCompanyContext);
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  if (!is_company_keys_user || company_keys.length === 0) return null;

  const labelFor = (key) => companies_map[key] || key;
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleSelect = (key) => {
    setSelectedCompanyKey(key);
    handleClose();
  };

  const cardCollapsed = (
    <Tooltip
      title={
        <div className="tooltipText">
          {`${t("selected_company")}: ${labelFor(selected_company_key)}`}
        </div>
      }
    >
      <div
        onClick={handleOpen}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "8px 0",
          margin: "8px 8px",
          borderRadius: 6,
          cursor: "pointer",
          background: open ? "#e6e9f5" : "#ffffff",
          border: "1px solid #d6d6d6",
        }}
      >
        <BusinessIcon style={{ color: "#0b1f82", fontSize: 22 }} />
      </div>
    </Tooltip>
  );

  const cardExpanded = (
    <div
      onClick={handleOpen}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 8,
        padding: "8px 10px",
        margin: "8px 12px",
        borderRadius: 6,
        cursor: "pointer",
        background: open ? "#e6e9f5" : "#ffffff",
        border: "1px solid #d6d6d6",
      }}
    >
      <BusinessIcon style={{ color: "#0b1f82", fontSize: 20 }} />
      <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
        <span style={{ fontSize: 10, color: "#6b6b6b", lineHeight: 1.2 }}>
          {t("company")}
        </span>
        <span
          style={{
            fontSize: 13,
            color: "#0b1f82",
            fontWeight: 500,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
          title={labelFor(selected_company_key)}
        >
          {labelFor(selected_company_key) || t("select_company")}
        </span>
      </div>
      <ExpandMoreIcon
        style={{
          color: "#a5a5a5",
          fontSize: 20,
          transform: open ? "rotate(180deg)" : "none",
          transition: "transform 0.2s",
        }}
      />
    </div>
  );

  return (
    <>
      {expanded ? cardExpanded : cardCollapsed}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            maxHeight: 320,
            minWidth: 220,
          },
        }}
      >
        {company_keys.map((key) => (
          <MenuItem
            key={key}
            selected={key === selected_company_key}
            onClick={() => handleSelect(key)}
            style={{ display: "flex", justifyContent: "space-between", gap: 12 }}
          >
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {labelFor(key)}
            </span>
            {key === selected_company_key && (
              <CheckIcon style={{ color: "#0b1f82", fontSize: 18 }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default CompanyKeySelector;
